module.exports = __webpack_public_path__ + "img/logo_icon_left.9b2e3c9e.svg";